import { render, staticRenderFns } from "./LinkModalV3.vue?vue&type=template&id=71072820&scoped=true"
import script from "./LinkModalV3.vue?vue&type=script&lang=js"
export * from "./LinkModalV3.vue?vue&type=script&lang=js"
import style0 from "./LinkModalV3.vue?vue&type=style&index=0&id=71072820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71072820",
  null
  
)

export default component.exports